import React, { useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useRemoveContentFromCollection } from "../../../collections/collectionServices";
import { useDeleteModuleItems } from "../../../modules/moduleServices";
import { useRemoveCollectionsFromAnthology } from "../../../anthologies/anthologyServices";
import { any, equals, identity } from "ramda";
import { notBlank } from "../../../../util/ext";

import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import StatusIconButton from "../../review/StatusIconButton";
import { useMediaPermissions } from "../../../../util/mediaUtil";

const useStyles = makeStyles(theme => ({
  endIcon: {
    width: 40,
    // alignSelf: "flex-end",
  },

  gutters: {
    paddingLeft: 50,
  },

  listItem: {
    paddingRight: 60,
  },

  mediaType: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.2rem",
    fontWeight: 700,
    lineHeight: "16px",
    textTransform: "uppercase",
  },

  menuItem: {
    "&:hover": {
      "& .media-type p": {
        color: theme.palette.primary.brandPrimary + " !important",
      },
    },
  },

  primary: {
    fontWeight: 700,
    fontSize: "1.8rem",
    lineHeight: "26px",
  },

  secondary: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: theme.palette.primary.brandPrimary,
    "&:hover": {
      color: theme.palette.primary.brandPrimary + " !important",
    },
  },
}));

const Primary = ({ parent, endIcon }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      // style={{ height: 58 }}
    >
      <Grid item xs container direction="column">
        <Grid item className="media-type">
          <Typography className={classes.mediaType}>
            {parent.mediaType}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography className={classes.primary}>{parent.name}</Typography>
        </Grid>
      </Grid>
      <Grid item xs="auto" className={classes.endIcon}>
        {endIcon}
      </Grid>
    </Grid>
  );
};

const ParentMenuItem = React.forwardRef(
  (
    { disableTypography, parent, secondary, child, onClick, setLoading },
    ref,
  ) => {
    const classes = useStyles();
    const { readOnly } = useMediaPermissions(parent);

    const removeContentFromCollection = useRemoveContentFromCollection();
    const removeCollectionsFromAnthology = useRemoveCollectionsFromAnthology();
    const deleteModuleItems = useDeleteModuleItems();

    const handleRemove = async event => {
      event.stopPropagation();

      try {
        if (equals(parent.mediaType, "module")) {
          await deleteModuleItems.mutateAsync({
            id: parent.id,
            ids: [child.id],
          });
        }

        if (
          equals(parent.mediaType, "anthology") &&
          equals(child.mediaType, "collection")
        ) {
          await removeCollectionsFromAnthology.mutateAsync({
            anthologyId: parent.id,
            mediaIds: [child.id],
          });
        }

        if (equals(parent.mediaType, "collection")) {
          await removeContentFromCollection.mutateAsync({
            collectionId: parent.id,
            contentIds: [child.id],
          });
        }
      } catch (err) {
        console.log(err);
      }
    };

    useEffect(() => {
      if (notBlank(setLoading)) {
        setLoading(
          deleteModuleItems.isPending ||
            removeContentFromCollection.isPending ||
            removeCollectionsFromAnthology.isPending,
        );
      }
    }, [
      setLoading,
      deleteModuleItems.isPending,
      removeContentFromCollection.isPending,
      removeCollectionsFromAnthology.isPending,
    ]);
    return (
      <MenuItem
        button
        ref={ref}
        onClick={event => {
          event.stopPropagation();
          onClick();
        }}
        classes={{
          root: classes.menuItem,
        }}
        ListItemClasses={{
          gutters: classes.gutters,
          secondaryAction: classes.listItem,
        }}
      >
        <ListItemText
          disableTypography={disableTypography}
          primary={
            <Primary
              parent={parent}
              endIcon={
                readOnly ? null : (
                  <StatusIconButton
                    icon={
                      any(identity, [
                        deleteModuleItems.isPending,
                        removeContentFromCollection.isPending,
                        removeCollectionsFromAnthology.isPending,
                      ]) ? (
                        <CircularProgress size={15} />
                      ) : null
                    }
                    tooltipTitle={
                      <div>
                        Remove From{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {parent.name}
                        </span>
                      </div>
                    }
                    onClick={handleRemove}
                    status="rejected"
                  />
                )
              }
            />
          }
          secondary={secondary}
          classes={{
            primary: classes.primary,
            secondary: classes.secondary,
          }}
        />
      </MenuItem>
    );
  },
);

export default ParentMenuItem;
